import React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import CoreCountTypeahead from './CoreCountTypeahead';

export const ProcessorCores = ({
    fromCore,
    toCore,
    onChange,
    disabled,
    classes,
    t
}) => (
    <Box className={classes.specificationWrapper}>
        <InputLabel
            className={classes.inputLabelSpecification}
            shrink
            variant="standard"
        >
            {t('cores')}
        </InputLabel>
        <Box className={classes.SpecificationBox}>
            <FormControl
                fullWidth
                margin="dense"
                className={classes.formControlWrapper}
            >
                <CoreCountTypeahead
                    animatedPlaceholder
                    labelId="from"
                    isClearable
                    name="from"
                    value={fromCore}
                    onChangeSuggestion={onChange('fromCoreCountTypes')}
                    disabled={disabled}
                    t={t}
                />

            </FormControl>
            <FormControl
                fullWidth
                margin="dense"
                className={classes.formControlWrapper}
            >
                <CoreCountTypeahead
                    animatedPlaceholder
                    labelId="to"
                    isClearable
                    name="to"
                    value={toCore}
                    onChangeSuggestion={onChange('toCoreCountTypes')}
                    disabled={disabled}
                    t={t}
                />
            </FormControl>
        </Box>
    </Box>
);
